/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ periods: NonNullable<unknown>, customers: NonNullable<unknown> }} Partner_Detail_Periods_Meta_AllInputs */



/**
* | output |
* | --- |
* | "{periods} periods closed, across {customers} customers" |
*
* @param {Partner_Detail_Periods_Meta_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_periods_meta_all = /** @type {((inputs: Partner_Detail_Periods_Meta_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Periods_Meta_AllInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.periods} Zeiträume abgeschlossen, über ${i?.customers} Kunden`)
	return /** @type {LocalizedString} */ (`${i?.periods} periods closed, across ${i?.customers} customers`)
});